const subdomainRegExMask = /[a-z0-9]+/gi; // met vlaggen g=global (alle matches) en i=case-insensitive

export function extractSubdomain(value: string) {
  return value.match(subdomainRegExMask).join('').toLowerCase();
}
